<template>
  <NavBar
    ref="navbar"
    :active="activeMenyIndex"
    :create_router_to="$acl.not.check('onlyTenders') ? null : ({name: 'newTender' })"
    :create_text="$t('Tenders.CreateTender')"
    :disabled="disabled"
    :loading.sync="loading"
    :mode.sync="mode"
    :types="types"
    unload
    @filterItems="filterByTypes">
    <template #btnCreate>
      <ButtonWithMenu
        v-if="$acl.check('onlyTenders') && growthBook.tenderflou"
        :disabled="loading || disabled"
        :label="$t('Tenders.CreateTender')"
        :mini="mini"
        :router-to="{name: 'newTender', query: {flou: 'default'}}">
        <div>
          <MenuItem
            data-qa="btn-create-smallflou"
            label="Короткие шаги (новое создание)"
            :to="{name: 'newTender', query: {flou: 'default'}}"/>
          <MenuItem
            data-qa="btn-create-smallflou"
            label="youcontrol (новое создание)"
            :to="{name: 'newTender', query: {flou: 'youcontrol'}}"/>
        </div>
      </ButtonWithMenu>
    </template>
    <template #list_item_count="{ item }">
      <template v-if="loading">
        <sIcon
          color="#ced8d7"
          size="14"
          spin
          type="loading"/>
      </template>
      <template v-else>
        {{ statistics[item.count] || 0 }}
      </template>
    </template>
    <template #additional_filters>
      <PinnedFiltersTemplatesTenders
        ref="filters_templates"
        :small="mode"
        @updatePinnedFilters="updatePinnedFilters">
        <template #filter_template="{ template, disabled: disabledFilter }">
          <TenderFilters
            :disabled="disabledFilter || disabled"
            :item="template"/>
        </template>
      </PinnedFiltersTemplatesTenders>
    </template>
  </NavBar>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import NavBar from 'components/common/blocks/NavBar.vue'
import TenderFilters from 'components/tenders/all tenders/TenderFiters.vue'
import ButtonWithMenu from 'components/common/elements/ButtonWithMenu.vue'
import PinnedFiltersTemplatesTenders from 'components/common/blocks/PinnedFiltersTemplatesTenders.vue'

import { filterSortMixin, storageMixin } from 'mixins'

import { mapGetters } from 'vuex'

export default {
  name: 'tendersNavBar',
  mixins: [
    filterSortMixin,
    storageMixin
  ],
  async mounted() {
    /*this.$_getPropFromDBStorage('tenders_menuType', 0)
      .then((menuType) => {
        if (menuType !== this.activeMenyIndex) {
          this.filterByTypes(this.types[menuType])
        }
      })*/
  },
  methods: {
    updatePinnedFilters(filterTemplate) {
      this.$root.$emit('setTemplateFilters', filterTemplate)
    },
    filterByTypes(item) {
      const index = this.types.findIndex(i => i.type === item.type)
      if (index !== -1) {
        const result = this.$_.cloneDeep(this.value)
        result.additionalFilter = item.type
        this.$emit('update:value', result)
      }
    },
  },
  computed: {
    ...mapGetters({
      //currentOrganization: 'getCurrentOrganization',
      userProfile: 'GET_USER',
    }),
    activeMenyIndex() {
      if (!this.types?.length) {
        return 0
      }
      return this.types.findIndex(i => i.type === this.value.additionalFilter)
    },
    mode: {
      get() {
        return this.mini
      },
      set(value) {
        this.$emit('update:mini', value)
      }
    },
  },
  props: {
    /**
     * Полный объект с фильтрами по тендерам
     */
    value: {
      type: Object
    },
    /**
     * Свернутый режим
     */
    mini: Boolean,
    loading: Boolean,
    disabled: Boolean,
    /**
     * Статисика по пунктам
     */
    statistics: {
      type: Object,
    },
    /**
     * Все пункты меню
     */
    types: {
      type: Array
    }
  },
  components: {
    NavBar,
    MenuItem,
    TenderFilters,
    ButtonWithMenu,
    PinnedFiltersTemplatesTenders
  }
}
</script>
